import { useState, useEffect, useCallback } from 'react';
import { usersAPI } from '../../services/api';
import { Table, Pagination } from '../../components/ui';

export default function ActivityPage() {
  const [logs, setLogs]       = useState([]);
  const [pagination, setPag]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState(1);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await usersAPI.logs({ page });
      setLogs(res.data.data || []);
      setPag(res.data.pagination);
    } catch { setLogs([]); }
    finally { setLoading(false); }
  }, [page]);

  useEffect(() => { load(); }, [load]);

  const ACTION_COLORS = {
    created: 'var(--green)', updated: 'var(--blue)',
    deleted: 'var(--red)',   published: 'var(--accent)',
    reviewed: 'var(--amber)',
  };

  const COLS = [
    {
      key: 'created_at', label: 'Time',
      render: v => <span style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{new Date(v).toLocaleString()}</span>,
    },
    { key: 'user_name', label: 'User', render: v => <span style={{ fontWeight: 500 }}>{v || 'System'}</span> },
    {
      key: 'action', label: 'Action',
      render: v => {
        const type = Object.keys(ACTION_COLORS).find(k => v?.startsWith(k));
        return (
          <span style={{
            fontSize: 11, fontWeight: 600, fontFamily: 'monospace',
            color: ACTION_COLORS[type] || 'var(--text-secondary)',
            background: ACTION_COLORS[type] ? ACTION_COLORS[type] + '18' : 'transparent',
            padding: '2px 8px', borderRadius: 4,
          }}>{v}</span>
        );
      },
    },
    { key: 'entity', label: 'Entity', render: v => <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{v || '—'}</span> },
    { key: 'ip_address', label: 'IP', render: v => <span style={{ fontSize: 11, fontFamily: 'monospace', color: 'var(--text-muted)' }}>{v || '—'}</span> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
        Full audit trail of admin actions — Class C governance requirement
      </div>
      <div style={{
        background: 'var(--bg-surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)', overflow: 'hidden',
      }}>
        <Table columns={COLS} data={logs} loading={loading} />
        <Pagination pagination={pagination} onPage={setPage} />
      </div>
    </div>
  );
}

